import * as React from 'react';
import ROUTES from '@Admin/shared/constants/routes';
import EmployeeManagement from '@shared/icons/EmployeeManagement';
import EmployeeManagementActive from '@shared/icons/EmployeeManagementActive';
import SubscriptionManagement from '@shared/icons/SubscriptionManagement';
import Contact from '@shared/icons/Contact';
import ContactActive from '@shared/icons/ContactActive';
import { ROLES } from '@shared/models/employee';
import ReviewIcon from '@shared/icons/ReviewIcon';
import ReviewIconActive from '@shared/icons/ReviewIconActive';
import ClientAssignmentIcon from '@shared/icons/ClientAssignmentIcon';
import ClientAssignmentIconActive from '@shared/icons/ClientAssignmentIconActive';
import ClientManagementIconActive from '@shared/icons/ClientManagementIconActive';
import ContentManagementIcon from '@shared/icons/ContentManagementIcon';
import ContentManagementIconActive from '@shared/icons/ContentManagementIconActive';
import AssessmentIcon from '@shared/icons/AssessmentIcon';
import AssessmentIconActive from '@shared/icons/AssessmentIconActive';
import PatientManagementIcon from '@shared/icons/PatientManagementIcon';
import PatientManagementIconActive from '@shared/icons/PatientManagementIconActive';
import ClientManagementIcon from '@shared/icons/ClientManagementIcon';

export interface Item {
  id: number;
  name: string;
  route: string;
  icon: React.ReactNode;
  activeIcon: React.ReactNode;
  roles: Array<string>;
}

export const MENU_LINKS: Array<Item> = [
  {
    id: 1,
    name: 'Assessments/Treatment Plan Review',
    route: `${ROUTES.private.assessmentTreatment}/tabs/0`,
    roles: [ROLES.Clinician, ROLES.SeniorClinician, ROLES.MasterClinician],
    icon: <ReviewIcon />,
    activeIcon: <ReviewIconActive />,
  } as Item,
  {
    id: 2,
    name: 'New Client Assignment',
    route: ROUTES.private.client,
    roles: [ROLES.SeniorClinician, ROLES.MasterClinician],
    icon: <ClientAssignmentIcon />,
    activeIcon: <ClientAssignmentIconActive />,
  } as Item,
  {
    id: 3,
    name: 'Employee Management',
    route: ROUTES.private.employee,
    roles: [ROLES.Admin, ROLES.SuperAdministrator],
    icon: <EmployeeManagement />,
    activeIcon: <EmployeeManagementActive />,
  } as Item,
  {
    id: 4,
    name: 'Pending Assessments',
    route: ROUTES.private.assessments,
    roles: [ROLES.Clinician, ROLES.SeniorClinician, ROLES.MasterClinician],
    icon: <AssessmentIcon />,
    activeIcon: <AssessmentIconActive />,
  } as Item,
  {
    id: 5,
    name: 'Client Management',
    route: ROUTES.private.families,
    roles: [ROLES.Clinician, ROLES.Admin, ROLES.SeniorClinician, ROLES.MasterClinician],
    icon: <ClientManagementIcon />,
    activeIcon: <ClientManagementIconActive />,
  } as Item,
  {
    id: 6,
    name: 'Patient Management',
    route: ROUTES.private.patients,
    roles: [ROLES.Clinician, ROLES.Admin, ROLES.SeniorClinician, ROLES.MasterClinician],
    icon: <PatientManagementIcon />,
    activeIcon: <PatientManagementIconActive />,
  } as Item,
  {
    id: 7,
    name: 'Content Management',
    route: `${ROUTES.private.content}/tabs/0?level=1`,
    roles: [ROLES.Admin, ROLES.MasterClinician],
    icon: <ContentManagementIcon />,
    activeIcon: <ContentManagementIconActive />,
  } as Item,
  {
    id: 8,
    name: 'Subscription Management',
    route: ROUTES.private.subscription,
    roles: [],
    icon: <SubscriptionManagement />,
    activeIcon: <SubscriptionManagement />,
  } as Item,
  {
    id: 9,
    name: 'Contact Info and FaQ',
    route: ROUTES.private.faq,
    roles: [],
    icon: <Contact />,
    activeIcon: <ContactActive />,
  } as Item,
];
